import React from 'react'
import './ActiveFilter.scss'
import { X } from 'react-bootstrap-icons'
import { Button } from 'react-bootstrap';

export interface ActiveFilterItem {
  label: string;
  value: string;
}

interface Props {
  filters: ActiveFilterItem[];
  onRemove: (value: string) => void;
  emptyText?: string;
}

// Función para saber si una fecha es hoy
const isToday = (dateStr: string) => {
  if (!dateStr) return false;
  // Normaliza a formato YYYY-MM-DD
  const [yyyy, mm, dd] = dateStr.split('-');
  const today = new Date();
  const todayStr = today.toISOString().split('T')[0];
  return dateStr === todayStr ||
    (yyyy == today.getFullYear().toString() &&
     mm == String(today.getMonth() + 1).padStart(2, '0') &&
     dd == String(today.getDate()).padStart(2, '0'));
};

const ActiveFilter: React.FC<Props> = ({ filters, onRemove, emptyText }) => {
  // Oculta filtros de fecha si son today
  const visibleFilters = filters.filter(f => {
    if (f.value === 'startDate' || f.value === 'endDate') {
      // Busca la fecha en el label (formato: 'Desde: YYYY-MM-DD' o 'Hasta: YYYY-MM-DD')
      const date = f.label.split(':')[1]?.trim();
      return date && !isToday(date);
    }
    return true;
  });

  if (!visibleFilters || visibleFilters.length === 0) {
    return <></>
  }

  return (
    <div className="active-filter-list" style={{padding:'1%'}}>
      {visibleFilters.map((filter) => (
        <Button
          key={filter.value}
          className="active-filter-btn"
          onClick={() => onRemove(filter.value)}
          variant='none'
        >
          {filter.label} <X/>
        </Button>
      ))}
    </div>
  );
};

export default ActiveFilter